"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isModelVersionAtLeast = isModelVersionAtLeast;
function isModelVersionAtLeast(model, requiredVersion) {
    const modelVersion = parseSemanticVersion(model.modelVersion);
    const required = parseSemanticVersion(requiredVersion);
    if (!modelVersion || !required) {
        return false;
    }
    return (modelVersion.major > required.major ||
        (modelVersion.major === required.major && modelVersion.minor > required.minor) ||
        (modelVersion.major === required.major &&
            modelVersion.minor === required.minor &&
            modelVersion.patch >= required.patch));
}
function parseSemanticVersion(version) {
    const match = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)$/.exec(version ?? '');
    if (!match) {
        return undefined;
    }
    const [major, minor, patch] = match.slice(1).map(toSafeInteger);
    if (major === undefined || minor === undefined || patch === undefined) {
        return undefined;
    }
    return { major, minor, patch };
}
function toSafeInteger(digits) {
    const value = Number(digits);
    return Number.isSafeInteger(value) ? value : undefined;
}
//# sourceMappingURL=model-version.js.map